









































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { IndexBar, IndexAnchor, Cell, Button, Search, Icon } from "vant";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

const createAccountModule = namespace("createAccount");

@Component({
  name: 'TaxResidentInfoCountryList',
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Search.name]: Search,
    [Icon.name]: Icon
  }
})
export default class TaxResidentInfoCountryList extends Vue {
  @createAccountModule.Getter("tax_place") getter_tax_place: any;
  @createAccountModule.Getter("country_list") country_list: any;
  @createAccountModule.Mutation("SAVE_TAX_PLACE_EXTRA") saveTaxPlaceExtra: any;

  keyword = "";
  isNoSearchResult = false;
  checkedCountryList: any = [];
  countryList = [];
  isApp = browser.isApp;

  @Watch("getter_tax_place", { deep: true, immediate: true })
  watchTaxPlace(val) {
    
    this.checkedCountryList = val.extra;
  }

  created() {
    this.countryList = this.country_list.normal;
  }

  handleCountryItemClick(item) {
    const index = this.checkedCountryList.indexOf(item.id);
    if (index > -1) {
      this.checkedCountryList.splice(index, 1);
    } else {
      this.checkedCountryList.push(item.id);
    }
    this.saveTaxPlaceExtra(this.checkedCountryList);
  }

  handleConfirmCountryList() {
    this.$router.go(-1);
  }

  handleSearch(value) {
    this.countryList = this.country_list.normal.filter(item => {
      return item.name.indexOf(value) > -1;
    });
    if (this.countryList.length == 0) {
      this.isNoSearchResult = true;
    } else {
      this.isNoSearchResult = false;
    }
  }
}
